import { get, put } from "./api_helper"

// branches
const getListPage = params => get("admin/rtw-inventory/page", params)
const getDetail = params =>
  get(`admin/rtw-inventory/${params.productId}/${params.size}`)
const putData = params =>
  put(`admin/rtw-inventory/${params.productId}/${params.size}`, params)

const getGrandTotal = () => get("admin/rtw-sales/grand-total")

const RtwInventoryAPI = {
  getListPage,
  getDetail,
  putData,
  getGrandTotal,
}

export default RtwInventoryAPI
